import { render, staticRenderFns } from "./accountdialog.vue?vue&type=template&id=6cd12655&scoped=true"
import script from "./accountdialog.vue?vue&type=script&lang=js"
export * from "./accountdialog.vue?vue&type=script&lang=js"
import style0 from "./accountdialog.vue?vue&type=style&index=0&id=6cd12655&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd12655",
  null
  
)

export default component.exports